import { getData, postData } from "../apiClient";

/**
 * GET /assign-room-facilities/get-room-lists
 */
export const GetAllRoomsTypeList = async () => {
    try {
        const result = await getData(`/assign-room-facilities/get-room-lists`);
        return { data: { success: true, ...result } };
    } catch (error) {
        console.error("Get All Room List API Error:", error);
        return {
            data: {
                success: false,
                error: error?.status === 400 ? error.error : error?.message,
                status: error?.status,
            },
        };
    }
};

/**
 * GET /assign-room-facilities/get-room-facility
 */
export const GetAllFacilitiesList = async () => {
    try {
        const result = await getData(`/assign-room-facilities/get-room-facility`);
        return { data: { success: true, ...result } };
    } catch (error) {
        console.error("Get All Facilities API Error:", error);
        return {
            data: {
                success: false,
                error: error?.status === 400 ? error.error : error?.message,
                status: error?.status,
            },
        };
    }
};

/**
 * GET /assign-room-facilities/:id
 */
export const GetAssignedFacilitiesList = async (typeId) => {
    try {
        const result = await getData(
            `/assign-room-facilities/get-room-facility/${typeId}`
        );
        return { data: { success: true, ...result } };
    } catch (error) {
        console.error("Get Assigned Facilities API Error:", error);
        return {
            data: {
                success: false,
                error: error?.status === 400 ? error.error : error?.message,
                status: error?.status,
            },
        };
    }
};

/**
 * POST /assign-room-facilities/
 * payload: { data: { faciliti_type_id, facility_id: [...], room_id: [...] } }
 */
export const CreateAssignRoomFacilities = async (data) => {
    try {
        const result = await postData(`/assign-room-facilities/`, data);
        return { data: { success: true, ...result } };
    } catch (error) {
        console.error("Assign Room Facilities API Error:", error);
        return {
            data: {
                success: false,
                error: error?.status === 400 ? error.error : error?.message,
                status: error?.status,
            },
        };
    }
};

/**
 * Backwards-compatible aliases (components may import these older names)
 */
export const GetAllFacilitiesByRoomType = GetAllFacilitiesList;
export const GetAssignedFacilities = GetAssignedFacilitiesList;
